// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedChinRestMovement_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.28013 5.99153L10.1608 0H12.5437L8.05893 6.92416C8.10269 6.94792 8.15321 6.97067 8.20589 6.99051C8.24589 7.00558 8.27922 7.01601 8.3 7.02204C8.30859 7.02453 8.31462 7.02615 8.31761 7.02693L8.34805 7.03392L11 8V17.5C11.0058 17.5614 11.0059 17.639 11.006 17.7226C11.0062 17.8946 11.0065 18.0923 11.0562 18.2287C11.1423 18.4646 11.262 18.6451 11.4173 18.767C11.5609 18.8797 11.8069 19 12.2613 19H17L19 24L17 24L15.5 21H12.2613C11.417 21 10.7212 20.7632 10.1823 20.3402C9.6552 19.9264 9.35193 19.3925 9.1774 18.9142C9.03719 18.5299 9.02095 18.0583 9.00925 17.7183C9.00645 17.637 9.00391 17.5632 9 17.5C9.00026 17.4896 9.00013 17.3654 9.00001 17.2433C8.99989 17.1258 8.99977 17.0101 9 17C9.00155 16.9321 9.00573 16.9014 9.00939 16.8746C9.01665 16.8213 9.02181 16.7835 9 16.5V9.5L7.81646 8.96313C7.79673 8.95801 7.77186 8.95128 7.7427 8.94282C7.68078 8.92486 7.59732 8.89845 7.501 8.86218C7.31625 8.7926 7.04733 8.67308 6.78923 8.4814C6.53409 8.29192 6.22119 7.98032 6.07649 7.5114C5.92273 7.01314 6.00815 6.50014 6.26038 6.02846L6.28013 5.99153Z" class="svg-bg"/>
  <path d="M14.5 5C15.3284 5 16 4.32843 16 3.5 16 2.67157 15.3284 2 14.5 2 13.6715 2 13 2.67157 13 3.5 13 4.32843 13.6715 5 14.5 5ZM5.43359 19 8.4337 24.0002H14.9228L13.768 22.0002H9.56608L7.76597 19H5.43359Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedChinRestMovement is a generated icon component.
 */
let IconMedChinRestMovement = IconMedChinRestMovement_1 = class IconMedChinRestMovement extends IconBaseElement {
    render() {
        return html `${IconMedChinRestMovement_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedChinRestMovement.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedChinRestMovement = IconMedChinRestMovement_1 = __decorate([
    customElement('zui-icon-med-chin-rest-movement')
], IconMedChinRestMovement);
export { IconMedChinRestMovement };
